// Copyright 2017 Sorama B.V.

import { IOverride } from "overrides/IOverride";

type LogFunction = (message?: unknown, ...optionalParams: unknown[]) => void;

/*
 * Override for printing "Sorama" in front of every log message for easy filtering of only our own messages in browser consoles
 */
export class ConsoleLogOverride implements IOverride {
    //#region constants
    public api = ["debug", "error", "info", "log", "trace", "warn"];
    //#endregion

    //#region IPolyfill Members
    public use(): IOverride {
        const consoleAny = <unknown>console;

        for (const functionName of this.api) {
            const originalFunction = <LogFunction>consoleAny[functionName];

            consoleAny[functionName] = function (...args: unknown[]) {
                originalFunction.call(this, "Sorama: ", ...args);
            };
        }

        return this;
    }
    //#endregion
}
